import './partials-js/refs';
import './partials-js/vars';
import './partials-js/onLoadPage';
import './partials-js/themeSwitch';
import './partials-js/authorization';
import './partials-js/openModal';
import './partials-js/addToWatch';
import './partials-js/watchedQueueSet';
import './partials-js/tuiPagination';
import './partials-js/footer-modal';
import './partials-js/closePreloader';
